import React, { useEffect, useState } from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, DatePicker, Form, Input, Modal, Select, Space, Table, Tooltip } from "antd";
import "./allocate_work_order.css";
import ModalDataWorkOrderAllocation from "./data_work_order_allocation";
import withAllocateWorkOrderLogic from "../../../components/hoc_allocate_work_order";
import { IoIosCloseCircleOutline } from "react-icons/io";

const AllocateWorkOrder: React.FC<any> = ({
    form,
    statusValue,
    isModalOpen,
    setIsModalOpen,
    Submitbtn,
    handleSubmit,
    Resetbtn,
    handleReset,
    handleVoid,
    transformStyle,
    columns,
    foremanOptions,
    workOrderData,
    isLoadingWorkOrder,
    brandOptions,
    handleRowClick,
    tableItems,
    autosaveStatus,
    highlightUnfinished,
    workOrderNo,
}) => {
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;

    return (
        <>
            <div id="i6ho" style={transformStyle}>
                <div className="gjs-grid-row" id="iy75">
                    <div className="gjs-grid-column" id="iwrj">
                        <Breadcrumb
                            items={[
                                {
                                    title: <HomeOutlined />,
                                },
                                {
                                    href: "#/dashboard/work_order_allocation",
                                    title: (
                                        <>
                                            <span>Work Order Allocation</span>
                                        </>
                                    ),
                                },
                                {
                                    title: "Allocation",
                                },
                            ]}
                        />
                    </div>
                </div>
                <div className="gjs-grid-row" id="iy75">
                    <div className="gjs-grid-column" id="iwrj">
                        <Button className="gr-button" onClick={handleReset}>
                            <Resetbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Reset
                        </Button>
                        <Button className="gr-button"
                            onClick={handleVoid}
                            disabled={!(statusValue === '1' || statusValue === 'Draft')}
                        >
                            <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Void
                        </Button>
                        <Space style={{ marginLeft: '10px' }}>
                            {autosaveStatus === 'processing' && (
                                <Tooltip title="Autosave sedang berjalan...">
                                    <LoadingOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'error' && (
                                <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                    <WarningOutlined style={{ color: '#ff4d4f' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'stopped' && (
                                <Tooltip title="Autosave Stopped">
                                    <StopOutlined style={{ color: '#bfbfbf' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'idle' && (
                                <Tooltip title="Autosave berhasil.">
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                </div>
                <div className="gjs-grid-row" id="i7s7g">
                    <div className="gjs-grid-column" id="iycgm">
                        <Form
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 450 }}
                            labelCol={{ style: { width: '150px', textAlign: "left" } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-purchase-request"
                            initialValues={{ status: "Draft" }}
                        >
                            <Form.Item
                                label="Status"
                                name="status"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Service Date"
                                name="service_date"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <DatePicker
                                    disabled
                                    format="DD/MM/YYYY"
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Brand"
                                name="brand"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Select
                                    disabled
                                    showSearch
                                    placeholder="Select Brand"
                                    optionFilterProp="label"
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                    options={brandOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Work Order"
                                style={{ marginBottom: "5px" }} >
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Form.Item
                                        name="work_order_no"
                                        noStyle
                                        style={{ width: "100%" }}
                                        rules={[{ required: true, message: 'Work Order No. wajib diisi.' }]}
                                    >
                                        <Input
                                            style={{ width: "100%" }}
                                            readOnly
                                        />
                                    </Form.Item>
                                    <Button
                                        type="primary"
                                        id="data_work_order_allocation"
                                        disabled={statusValue === '7' || statusValue === 'On Going' || workOrderNo}
                                        onClick={() => setIsModalOpen(true)}
                                        icon={
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>}
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item
                                label="Foreman"
                                name="foreman"
                                style={{
                                    marginBottom: "5px",
                                    marginTop: "50px",
                                }}
                            >
                                <Select
                                    variant="borderless"
                                    showArrow={false}
                                    disabled
                                    options={foremanOptions}
                                    style={{ fontWeight: 'bold', color: '#555', width: '100%', cursor: 'default' }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Service Advisor"
                                name="service_advisor"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Model"
                                name="model"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Chassis No."
                                name="chassis_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="No Polisi"
                                name="no_polisi"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Customer Name"
                                name="customer_name"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="FRT"
                                name="frt"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
                <div className="gjs-grid-row" id="ibgiw">
                    <div className="gjs-grid-column" id="ijnxx">
                        <Table
                            columns={columns}
                            dataSource={tableItems}
                            rowClassName={(record) => {
                                if (highlightUnfinished && (record.service_status === 'OP' || record.service_status === 'P')) {
                                    return 'status-red-row';
                                }
                                return '';
                            }}
                        />
                    </div>
                </div>
            </div>
            <Modal title="Data Work Order" open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null} width={1000} centered>
                <ModalDataWorkOrderAllocation
                    workOrderData={workOrderData}
                    isLoading={isLoadingWorkOrder}
                    onRowClick={handleRowClick}
                />
            </Modal>
        </>
    );
};
export default withAllocateWorkOrderLogic(AllocateWorkOrder);